import clsx from 'clsx';
import { Loader2 } from 'lucide-react';

export default function Spinner({ className, label = 'Loading…' }) {
  return (
    <div className="flex items-center justify-center gap-2 text-slate-500" role="status">
      <Loader2 className={clsx('h-5 w-5 animate-spin', className)} aria-hidden />
      <span className="text-sm">{label}</span>
    </div>
  );
}
